
import ModalPopup from '~/components/app/modal-popup'
import EmailLink from '~/components/app/modal/EmailLink'

export default {
  name: 'login',
  components: { EmailLink, ModalPopup },
  middleware: ['not-authenticated'],
  data() {
    return {
      stage: 1,
      email: '',
      password: '',
      showModal: false,
      modalTitle: '',
      modalBody: '',
    }
  },
  head() {
    return {
      meta: [{ hid: 'robots', name: 'robots', content: 'noindex' }],
    }
  },
  methods: {
    async login() {
      this.$fire.auth
        .signInWithEmailAndPassword(this.email, this.password)
        .then(() => {
          if (typeof $crisp !== 'undefined') {
            $crisp.push(['set', 'session:event', [[['finish_login', { email: this.email }, 'green']]]])
          }

          if (typeof posthog !== 'undefined') {
            posthog.capture('finish_login', { email: this.email })
          }

          setTimeout(() => {
            this.$router.push(`/app/`)
          }, 1000)

        })
        .catch((error) => {
          if (typeof $crisp !== 'undefined') {
            $crisp.push(['set', 'session:event', [[['login_error', { error, email: this.email }, 'orange']]]])
          }

          if (typeof posthog !== 'undefined') {
            posthog.capture('login_error')
          }
          this.showModal = true
          this.modalTitle = 'Error'
          this.modalBody = error
        })
    },
  },
}
